import React from 'react';

import {Row, Col, Button, Spin, Icon, Tag, Modal} from 'antd';

import './OrderInformationPanel.scss';
import FieldValueVerticalCell from 'components/general/FieldValueVerticalCell';

import { displayGenericError } from 'common/notifications';
import {generateUploadedFile, getOrderAttachedFiles, uploadInvoice} from "../api/api";
import FileDrop from "react-file-drop";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import DocumentOrderUploading from "./DocumentOrderUploading";

class OrderDetailsPanel extends React.Component {
    state={
        invoiceUploading: false
    }
  downloadInvoice = (id) => {
    generateUploadedFile(id)
        .then(response => {
          // let win = window.open(response.link, "_blank");
          // win.focus();
        })
        .catch(error => {
          displayGenericError(error);
        });
  }
    handleRemove=(orderId, id) =>{
        this.props.handleRemoveFile(orderId, id)
    }
    handleInvoiceDrop = (files, event) => {
        this.doUploadFile(files[0]);
    };

    handleUploadClick = () => {
        this.refs.fileUploader.click();
    };

    /*
    onUploadedFileChanged = event => {
        let file = event.target.files[0];
        this.doUploadFile(file);
    };
    doUploadFile = file => {

        const id = this.props.order.id;
        this.setState({
            invoiceUploading: true
        });
        const fileType = 'CUSTOMER_PAYMENT_SLIP';
        const otherTypeDescription = '';
        const remarks = 'Uploaded Invoice';
        uploadInvoice({
            id,
            fileType,
            otherTypeDescription,
            remarks,
            file
        })
            .then(response => {
                let invoice = response.filter(file => file.attachedFileType == 'CUSTOMER_PAYMENT_SLIP');
                this.setState({
                    invoiceUploading: false,
                    invoiceFileName: invoice[0].name,
                });
                this.props.uploaded(this.props.order);
            })
            .catch(error => {
                this.setState({
                    invoiceUploading: false
                });
                displayGenericError(error);
            });
    };
    */


    handleCancelDocument = () => {
        this.setState({
            isUserDocumentOpen: false
        })
    }
    openDocumentModal = () => {
        this.setState({
            isUserDocumentOpen: true
        })
    }

  render() {
    const intl = this.props.useIntl;
    let invoices = this.props.orderPaymentSlip.filter(s=>s.orderId === this.props.order.id);

    return (
      <div>
        <Row gutter={16}>
          <Col sm={9}>
            <FieldValueVerticalCell className="bp-table-cell" title={intl.formatMessage({id: "app.panel.orderdetailspanel.purposeoftransfer"})} value={this.props.order.purposeOfTransferName} />
          </Col>
          <Col sm={15}>
            <FieldValueVerticalCell className="bp-table-cell" title={intl.formatMessage({id: "app.panel.orderdetailspanel.notetobeneficiary"})} value={this.props.order.referenceText} />
          </Col>
        </Row>
          <Row gutter={16} className="bp-margin-top-smallest">
                <Col sm={9}>
                    <FieldValueVerticalCell className="bp-table-cell" title={intl.formatMessage({id: "app.panel.orderdetailspanel.internalreference"})}
                                            value={this.props.order.internalReference}/>
                </Col>
                <Col sm={9}></Col>
                <Col sm={15}>
                <Spin spinning={this.state.invoiceUploading}>
                        <div className="bp-margin-top-smallest" style={{marginBottom: '10px'}}>
                            {(this.props.currentUser && !this.props.currentUser.role.readOnly &&
                                (<>
                                <Button
                                        type="primary"
                                        onClick={this.openDocumentModal}
                                        style={{marginLeft: "10px"}} icon="upload"
                                    >
                                        {' '}<FormattedMessage id="app.panel.orderdetailspanel.uploadordragproof"/>
                                    </Button>
                                    <Modal title={intl.formatMessage({id: "app.panel.orderinfomationpanel.order.documents"})} visible={this.state.isUserDocumentOpen}
                                           onCancel={this.handleCancelDocument}
                                           width={700}
                                           style={{ resize: "none" }}
                                           footer={[
                                               <Button onClick={this.handleCancelDocument}><FormattedMessage id="app.common.close"/></Button>
                                           ]}>
                                        <DocumentOrderUploading handleCorporateSubmit ={this.handleCorporateSubmit}
                                                                order={this.props.order}
                                                                documents={this.props.documents}
                                        />
                                    </Modal>
                                </>)
                            )}

                        </div>
                    </Spin>
                </Col>
          </Row>
      </div>
    )
  }

}


const mapStateToProps = state =>{
    return {
        currentUser: state.user.currentUser
    }
}

const mapDispatchToProps = dispatch =>{

}

export default withRouter(
    connect(mapStateToProps,mapDispatchToProps) (
        withUseIntl(OrderDetailsPanel)));
